import React, { useState } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../../Components/helper';
import * as action from '../Store/PurchaseOrder.action';
import PreviewModal from './PreviewModal';
import PurchaseOrderStateProvider from '../PurchaseOrderContext/index';

export function HistoryList() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { devOrderId } = useParams();
  const {
    purchaseOrderData: { poHistoryList },
  } = useSelector((reduxState) => reduxState);
  const [state, setState] = useState({
    previewModalState: false,
  });

  const handlePOpreview = async (value) => {
    await dispatch(action.previewData(value?._id));
    const obj = {
      devOrderId,
      allDetails: true,
    };
    dispatch(action.fetchDevorderSupplier(obj));
    dispatch(action.fetchDevorder(devOrderId));
    setState((prevState) => ({ ...prevState, previewModalState: true }));
  };

  const togglePreviewMode = async () => {
    dispatch(action.clearPreviewData());
    setState((prevState) => ({ ...prevState, previewModalState: false }));
  };

  const showCreatedandModified = (item) => {
    return (
      <button className="btn-tbl-action" type="button" style={{ margin: '0' }}>
        <div className="info-container testing-action-spaceremoval">
          <span className="icon-info  f-18" />
          <div className="info-content">
            {item?.createdBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('HISTORY.CREATED')}</strong> : {`${item.createdBy?.firstName} ${item.createdBy?.lastName} | `}
                {moment(item.createdAt).format('D-MMMM-YYYY, h:mm a')}
              </p>
            )}
            {/* date formate need to be proper */}
          </div>
        </div>
      </button>
    );
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table custom-table font-13 mb-5">
          <thead>
            <tr>
              <th>
                <span className="cursor-pointer">{t('HISTORY.PURCHASE_ORDER_NUMBER')}</span>
              </th>
              <th>
                <span className="cursor-pointer">{t('HISTORY.TEMPLATE_NAME')}</span>
              </th>
              <th>
                <span className="cursor-pointer">{t('HISTORY.SUPPLIER')}</span>
              </th>
              <th>
                <span className="cursor-pointer">{t('HISTORY.CURRENCY')}</span>
              </th>
              <th>
                <span className="cursor-pointer">{t('HISTORY.COLOURS')}</span>
              </th>
              <th>
                <span className="cursor-pointer">{t('HISTORY.LOG_BY')}</span>
              </th>
              <th className="w-150px">{t('HISTORY.ACTION')}</th>
            </tr>
          </thead>
          <tbody>
            {checkArray(poHistoryList) ? (
              poHistoryList.map((hist, i) => {
                return (
                  <tr key={i}>
                    <td>{hist?.poOrderNo || '--'}</td>
                    <td>{hist?.template || '--'}</td>
                    <td>{hist?.supplier || '--'}</td>
                    <td>{hist?.currency || '--'}</td>
                    <td>{hist?.colours || '--'}</td>
                    <td>
                      {`${hist?.createdBy?.firstName} ${hist?.createdBy?.lastName} at ${
                        hist?.updatedAt ? moment(hist?.updatedAt).format('DD-MMM-YYYY HH:mm') : ''
                      }`}
                    </td>
                    <td>
                      <button
                        className="btn-tbl-action"
                        title={t('HISTORY.PREVIEW')}
                        type="button"
                        onClick={() => handlePOpreview(hist)}
                        aria-label={t('HISTORY.PREVIEW')}
                      >
                        <span className="icon-preview-template" />
                      </button>
                      {showCreatedandModified(hist)}
                    </td>
                  </tr>
                );
              })
            ) : (
              <td colSpan={7}>
                <span className="d-flex align-items-center justify-content-center">{t('HISTORY.NO_RECORDS_FOUND')}</span>
              </td>
            )}
          </tbody>
        </table>
      </div>
      {state.previewModalState && (
        <PurchaseOrderStateProvider fromPreview>
          <PreviewModal onOpen={state.previewModalState} toggle={togglePreviewMode} />
        </PurchaseOrderStateProvider>
      )}
    </>
  );
}

export default HistoryList;
